export class OfferFilterSettingsModel {
  public number: string;
  public client: string;
  public timePeriodId: number;
  public startDate: string;
  public endDate: string;
  public statusId: number;
  public loadedOffers: Array<number>;
}